"use client";

import { useState } from "react";
import NutritionModal from "./NutritionModal";

export default function NutritionInfoButton({ itemName, nutritionalInfo, accentText }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`text-sm font-semibold underline underline-offset-2 ${accentText} hover:opacity-80`}>
        View Nutritional Info
      </button>
      {open && (
        <NutritionModal
          itemName={itemName}
          nutritionalInfo={nutritionalInfo}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
